import { SuperModel } from './super-model.model';
import { SalesOrderItem } from '@common/core/models/order-item.model';

export class ShipFromStoreItem extends SuperModel {
  orderItem: SalesOrderItem;
  qty: number;
  productSku: string;

  constructor(data: any = {}) {
    super(data);
    if (data.orderItem) {
      this.orderItem = new SalesOrderItem(data.orderItem);
    }
  }

  get serialised() {
    return {};
  }
}
